export default {
    TRISTATE_DISABLED: 0,
    TRISTATE_ON: 1,
    TRISTATE_OFF: 2,
    COMMAND_BUTTON_SELECTED_CLASS: 'selected',
    COMMAND_BUTTON_DISABLED_CLASS: 'disabled',
    CURSOR_LOCATIONS: {
        START: 'start',
        END: 'end',
        ALL: 'all',
        NONE: 'none'
    },
    KEYS: {
        CTRL: 1114112,
        ALT: 4456448,
        SHIFT: 2228224
    },
    EFFECTS: {
        effect_0: {
            label: '-',
            cssData: 2
        },
        effect_1: {
            label: 'A',
            cssData: 'rgba(255, 255, 255, 0.6) 1px 1px 1px, rgba(0, 0, 0, 0.6) -1px -1px 1px'
        },
        effect_2: {
            label: 'B',
            cssData: 'rgba(0, 0, 0, 0.298039) 0px 5px 0px'
        },
        effect_3: {
            label: 'C',
            cssData: 'rgba(0, 0, 0, 0.4) 0px 4px 5px'
        },
        effect_4: {
            label: 'D',
            cssData: 'rgba(0, 0, 0, 0.498039) -1px -1px 0px, rgba(0, 0, 0, 0.498039) -1px 1px 0px, rgba(0, 0, 0, 0.498039) 1px 1px 0px, rgba(0, 0, 0, 0.498039) 1px -1px 0px'
        },
        effect_5: {
            label: 'E',
            cssData: 'rgb(255, 255, 255) -1px -1px 0px, rgb(255, 255, 255) -1px 1px 0px, rgb(255, 255, 255) 1px 1px 0px, rgb(255, 255, 255) 1px -1px 0px'
        },
        effect_6: {
            label: 'F',
            cssData: 'rgb(255, 255, 255) 0px 0px 6px'
        },
        effect_7: {
            label: 'G',
            cssData: 'rgb(200, 200, 200) 1px 1px 0px, rgb(180, 180, 180) 0px 2px 0px, rgb(160, 160, 160) 0px 3px 0px, rgba(140, 140, 140, 0.498039) 0px 4px 0px, rgb(120, 120, 120) 0px 0px 0px, rgba(0, 0, 0, 0.498039) 0px 5px 10px'
        },
        effect_8: {
            label: 'H',
            cssData: 'rgb(255, 255, 255) 3px 3px 0px, rgba(0, 0, 0, 0.2) 6px 6px 0px'
        },
        effect_9: {
            label: 'I',
            cssData: 'rgba(10, 189, 240, 0.298039) 3px 3px 0px, rgba(254, 1, 1, 0.298039) -3px -3px 0px'
        }
    },
    DEFAULT_THEME_DISPLAY_NAME: {
        font_0: 'text_editor_theme_1',
        font_2: 'text_editor_theme_2',
        font_3: 'text_editor_theme_3',
        font_4: 'text_editor_theme_4',
        font_5: 'text_editor_theme_5',
        font_6: 'text_editor_theme_6',
        font_7: 'text_editor_theme_7',
        font_8: 'text_editor_theme_8',
        font_9: 'text_editor_theme_9'
    },
    DEFAULT_THEME_TAGS: {
        font_0: 'h1',
        font_2: 'h2',
        font_3: 'h3',
        font_4: 'h4',
        font_5: 'h5',
        font_6: 'h6',
        font_7: 'p',
        font_8: 'p',
        font_9: 'p'
    },
    LANG_TO_EXAMPLE_KEY: {
        latin: '',
        'latin-ext': 'text_editor_font_example_latin_ext_constant',
        cyrillic: 'text_editor_font_example_cyrillic_constant',
        japanese: 'text_editor_text_editor_font_example_japanese_constant',
        korean: 'text_editor_font_example_korean_constant',
        arabic: 'text_editor_font_example_arabic_constant',
        hebrew: 'text_editor_font_example_hebrew_constant'
    },
    FONT_GROUPS: {
        'my-uploads': 'text_editor_font_dropdown_my_fonts',
        latin: 'text_editor_font_dropdown_all_fonts',
        'latin-ext': 'add_languages_eastern_european',
        cyrillic: 'add_languages_cyrillic',
        japanese: 'add_languages_japanese',
        korean: 'add_languages_korean',
        arabic: 'add_languages_arabic',
        hebrew: 'add_languages_hebrew'
    },
    DEFAULT_TRANSLATIONS: {
        text_editor_font_example_arabic_constant: 'مثال',
        text_editor_font_example_hebrew_constant: 'דוגמא',
        add_languages_arabic: 'Arabic',
        add_languages_hebrew: 'Hebrew',
        text_editor_font_dropdown_all_fonts: 'All Fonts',
        add_languages_cyrillic: 'Cyrillic',
        add_languages_japanese: 'Japanese',
        add_languages_korean: 'Korean',
        text_editor_font_dropdown_my_fonts: 'My Fonts',
        text_editor_theme_1: 'Site Title',
        text_editor_theme_2: 'Page Title',
        text_editor_theme_3: 'Huge Heading',
        text_editor_theme_4: 'Large Heading',
        text_editor_theme_5: 'Basic Heading',
        text_editor_theme_6: 'Small Heading',
        text_editor_theme_7: 'Paragraph 1',
        text_editor_theme_8: 'Paragraph 2',
        text_editor_theme_9: 'Paragraph 3',
        font_slider_label: 'Font size (px)',
        lineheight_slider_label: 'Line spacing',
        letterspacing_slider_label: 'Character spacing',
        text_editor_line_spacing_automatic: 'Automatic',
        text_editor_line_spacing_customize: 'Customize'
    }
}



// WEBPACK FOOTER //
// ./src/utils/constants.js